// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Allocation } from '@daml.js/splice-api-token-allocation/lib/Splice/Api/Token/AllocationV1';
import InterfaceContract from './InterfaceContract';

export const groupAllocations: (
  allocations: InterfaceContract<Allocation>[],
) => Record<string, Record<string, Record<string, InterfaceContract<Allocation>>>> = (
  allocations,
) => {
  return allocations.reduce(
    (acc, allocation) => {
      const view = allocation.view(Allocation);
      const settlementId = view.allocation.settlement.settlementRef.id;
      const settlementCid = view.allocation.settlement.settlementRef.cid;
      const settlementCidString = settlementCid ? settlementCid.toString() : '';
      const { transferLegId } = view.allocation;

      if (!acc[settlementId]) {
        acc[settlementId] = {};
        acc[settlementId][settlementCidString] = {};
      }

      if (!acc[settlementId][settlementCidString]) {
        acc[settlementId][settlementCidString] = {};
      }

      acc[settlementId][settlementCidString][transferLegId] = allocation;

      return acc;
    },
    {} as Record<string, Record<string, Record<string, InterfaceContract<Allocation>>>>,
  );
};
